<template lang="html">
  <div v-if="getLoadingState" class="__loading">
    <v-overlay :value="overlay" color="white">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      overlay: true
    }
  },
  computed: {
    ...mapGetters(['getLoadingState'])
  }
}
</script>
